module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_3250_Active@1x-ce43e80fd2c11592fdd3452b9fafd7aa.png";